<template>
  <div class="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-gradient-to-br from-[#0d4169] via-[#0d4169] to-[#245ea6] text-white overflow-hidden">
    <div class="absolute inset-0 opacity-30 pointer-events-none">
      <div class="absolute -top-24 -left-16 w-72 h-72 rounded-full bg-white/10 blur-3xl"></div>
      <div class="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-[#e9f2f8]/10 blur-3xl"></div>
    </div>

    <div class="relative animate-splash-rise flex flex-col items-center px-8 text-center">
      <div class="relative mb-6">
        <span class="absolute inset-0 rounded-full animate-pulse-ring bg-white/20"></span>
        <div class="relative h-24 w-24 rounded-full bg-white/10 border border-white/25 shadow-2xl flex items-center justify-center overflow-hidden backdrop-blur-sm">
          <!-- <img src="../assets/logo.png" alt="Ahun Jobs" class="h-16 w-auto object-contain brightness-0 invert" /> -->
        </div>
      </div>

      <h1 class="text-2xl md:text-3xl font-extrabold tracking-tight">Welcome to Ahun Jobs</h1>
      <p class="mt-3 text-sm text-white/80 max-w-xs leading-relaxed">
        {{ error || message || 'Getting everything ready…' }}
      </p>

      <div v-if="!error" class="mt-8 flex items-center gap-1.5">
        <span class="h-2 w-2 rounded-full bg-white animate-dot-fade" style="animation-delay: 0ms"></span>
        <span class="h-2 w-2 rounded-full bg-white animate-dot-fade" style="animation-delay: 200ms"></span>
        <span class="h-2 w-2 rounded-full bg-white animate-dot-fade" style="animation-delay: 400ms"></span>
      </div>

      <button
        v-else
        type="button"
        class="mt-8 px-5 py-2 rounded-lg bg-white text-[#0d4169] font-bold text-sm shadow-md"
        @click="$emit('retry')"
      >
        Retry
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SplashScreen',
  props: {
    message: { type: String, default: '' },
    error: { type: String, default: '' },
  },
  emits: ['retry'],
}
</script>
